<template>
  <div id="con">
    <div class="left">
      <el-menu @select="loadView">
        <el-menu-item index="/company/companyintro" ref="ref_load">
          <i class="el-icon-info"></i>
          <span class="text">企业简介</span>
        </el-menu-item>
        <el-menu-item index="/company/chairman">
          <i class="el-icon-user-solid"></i>
          <span class="text">董事长简介</span>
        </el-menu-item>
        <el-menu-item index="/company/culture">
          <i class="el-icon-s-platform"></i>
          <span class="text">企业文化</span>
        </el-menu-item>
        <el-menu-item index="/company/environment">
          <i class="el-icon-s-home"></i>
          <span class="text">企业环境</span>
        </el-menu-item>
        <el-menu-item index="/company/honor">
          <i class="el-icon-s-flag"></i>
          <span class="text">荣誉证书</span>
        </el-menu-item>
        <el-menu-item index="/company/patent">
          <i class="el-icon-s-grid"></i>
          <span class="text">专利说明</span>
        </el-menu-item>
        <el-menu-item index="/company/join">
          <i class="el-icon-s-shop"></i>
          <span class="text">加盟世有</span>
        </el-menu-item>
        <el-menu-item index="/company/connect">
          <i class="el-icon-location"></i>
          <span class="text">联系我们</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right">
      <router-view />
    </div>
  </div>
</template>

<style scoped>
#con {
  width: calc(100% - 32px);
  max-width: 1366px;
  margin: 0 auto;
  background-color: #ffffff;
  overflow: hidden;
  margin-top: 32px;
  margin-bottom: 132px;
}
#con > .left {
  width: 144px;
  overflow: hidden;
  float: left;
}
#con > .right {
  width: calc(100% - 144px);
  float: left;
}
@media screen and (max-width: 600px) {
  #con {
    width: 100%;
    margin-top: 32px;
    margin-bottom: 132px;
  }
  #con > .left {
    width: 100%;
    overflow: hidden;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9999;
  }
  .text {
    display: none;
  }
  #con > .right {
    width: 100%;
    float: left;
  }
  .el-menu-item {
    float: left;
    width: calc(100% / 8);
    border-top: 1px solid #efeff4;
  }
}
</style>

<script>
export default {
  methods: {
    loadView(path) {
      this.$router.push(path);
    }
  },
  mounted() {
    let that = this;
    if (that.$route.path == "/company") {
      that.$refs.ref_load.$el.click();
    }
  }
};
</script>
